<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardBody>
      <CRow>
        <FilterPembayaran />        
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <CSelect
              class="float-left"
              label="Data Per Halaman"
              placeholder="Data Per Halaman"
              @change="changePageSize"
              :options="[10, 25, 50, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-4 ml-auto">
          <div class="form-group">
            <CInput
              class="float-right"
              label="Pencarian"
              placeholder="Cari Data .."
              v-model="searchPembayaran"
            />
          </div>
        </div>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nominal="{ item }">
              <td class="py-2">Rp. {{formatPrice(item.nominal) ? formatPrice(item.nominal) : '0' }}</td>
            </template>
            <template #tanggal_pembayaran="{ item }">
              <td class="py-2">{{ item.tanggal_pembayaran ? item.tanggal_pembayaran : '-' }}</td>
            </template>
            <template #status_pembayaran="{item}">
              <td class="py-2 font-weight-bold text-success" v-if="item.status_pembayaran == 'settlement'">Lunas</td>              
              <td class="py-2 font-weight-bold text-warning" v-else-if="item.status_pembayaran == 'pending'">Menunggu Pembayaran</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'expire'">Expired</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'failure'">Pembayaran Gagal</td>
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == null">Dibatalkan</td>
              <td class="py-2 font-weight-bold text-danger"  v-else>Gagal</td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_read">
                <CButton
                  color="warning"
                  class="btn-sm text-white mr-2"
                  v-c-tooltip="'Data Diri'"
                  square
                  @click="$router.push('/keanggotaan/data-anggota/data-diri/'+item.id_user)">
                <font-awesome-icon icon="user" /> 
                </CButton>
                <CButton
                  color="success"
                  class="btn-sm text-white"
                  v-c-tooltip="'E-Kuitansi'"
                  square
                  @click="$router.push('/keuangan/pembayaran/detail-invoice/'+item.id_invoice)">
                <font-awesome-icon icon="coins" /> 
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPagePembayaran"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import PaymentService from "@/services/finance/payment.service";
import FilterPembayaran from "@/components/finance/pembayaran/FilterPembayaranReguler";
import { Pagination } from "@/mixins/Pagination";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: true
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: true
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: true
  },
  {
    key: "nama_item",
    label: "Jenis Pembayaran",
    sorter: true,
    filter: true
  },
  {
    key: "nominal",
    label: "Nominal",
    sorter: true,
    filter: true,
    _style: 'width: 15%'
  },
  {
    key: "tanggal_pembayaran",
    label: "Tanggal Transaksi",
    sorter: true,
    filter: true
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: false,
    filter: false
  },  
  {
    key: "aksi",
    label: "Aksi",
    sorter: false,
    filter: false,
    _style: 'text-align: center'
  },
  
];

export default {
  name: "Payment",
  mixins: [Pagination, exportUtils, AlertUtils],
  components: {
    FilterPembayaran,
  },
  data() {
    return {
      items: [],
      dataTahun: [],
      details: [],
      tipe: "pembayaran_sertifikasi",
      fields,
      no: 1,      
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      currentPagePembayaran: 0,
      content: [],
      tipe: '',
      id: '',
      searchPembayaran: '',
      role_status: null
    };
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    pageChange() {
      this.getData(val - 1, this.pageSize, this.tipe, this.searchPembayaran, this.periode, this.id);
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/keuangan/pembayaran' );  
      this.role_status = data;
    },

     changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
        this.getData('0', this.pageSize, this.tipe, this.searchPembayaran, this.periode, this.id);
    },

    changePelatihan(value) {
      this.roleData();
      this.periode = value.periode
      this.id = value.id
      this.getData(
        "0",
        this.pageSize,
        this.tipe,
        this.searchPembayaran,
        value.periode,
        value.id
      );
    },

    download(value) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.periode = value.periode
      this.id = value.id
      PaymentService.download(this.tipe, value.periode, value.id)
      .then(response => {
          loader.hide()
          this.exportData(response.data, 'Data-Pembayaran-Sertifikasi-Reguler');
          this.alertExportSuccess();
        })
      .catch(error => {
        this.alertExportFailed();
        loader.hide()
      })  
    },   

    getData(currentPagePembayaran, pageSize, tipe, filter, periode, id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      PaymentService.getData(currentPagePembayaran, pageSize, tipe, filter, periode, id)
        .then((response) => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPagePembayaran = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
  },
};
</script>